// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".attachment-button .v-icon,.attachment-button .v-progress-circular{color:#d32f2f}.attachment-button--clickable .v-chip__content{cursor:pointer}.attachment-button--highlight .attachment-button__text{color:#d32f2f!important}.attachment-button--deactivated .v-chip__content{cursor:not-allowed}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
